<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>故障库</span>
                </div>
            </div>
            <el-form label-width="100px" :model="searchData" ref="formRule">
                <el-form-item label="产品">
                    <el-select v-model="searchData.product" placeholder="请选择产品">
                        <el-option :label="item" :value="item" v-for="item in appData.product" :key="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="语言">
                    <el-select v-model="searchData.lang" placeholder="请选择语言">
                        <el-option :label="item" :value="key" v-for="(item, key) in appData.lang" :key="key"></el-option>
                    </el-select>
                </el-form-item>
                <div class="faq_box">
                    <div class="faq_title">故障排查 <i class="el-icon-circle-plus-outline add_faq" @click="addFaqItem(false)"></i></div>
                    <div class="add_faq_box">
                        <div class="add_item" v-for="(item, i) in addData" :key="i + 98765224" @click="editIndex = i">
                            <el-form-item label="故障类型">
                                <el-input type="text" v-model="item.title" placeholder="请输入故障类型"></el-input>
                            </el-form-item>
                            <el-form-item label="内容">
                                <!-- <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" v-model="item.content" placeholder="请输入内容"></el-input> -->
                                <vue-editor v-model="item.content" :editorToolbar="customEditorToolbar"></vue-editor>
                            </el-form-item>
                            <el-form-item label="图片">
                                <upload ref="create_upload_img" v-if="imgShow" :fileDire="'product-service-center/' + fileDire + '/img'" :limit="1" :files="(mconfigFile[i] && mconfigFile[i].imgUrl) ? mconfigFile[i].imgUrl : []" :download="'false'" accept="image/*" @fileChange="fileChangeImg">
                                    <template slot="desc">
                                        <span slot="tip" class="el-upload__tip upload_desc">{{`附件数量上限1个`}}</span>
                                    </template>
                                </upload>
                            </el-form-item>
                            <el-form-item label="视频" class="textarea_item">
                                <upload ref="create_upload_video" v-if="videoShow" :files="mconfigFile[i] && mconfigFile[i].videoUrl ? mconfigFile[i].videoUrl : []" :fileDire="'product-service-center/' + fileDire + '/video'" :limit="1" :download="'false'" accept="video/*" @fileChange="fileChangeVideo">
                                    <template slot="desc">
                                        <span slot="tip" class="el-upload__tip upload_desc">{{`附件数量上限1个`}}</span>
                                    </template>
                                </upload>
                            </el-form-item>
                            <div class="act_box">
                                <i class="el-icon-circle-plus-outline add_faq" @click="addFaqItem(i+1)"></i>
                                <i class="el-icon-delete del_faq" @click="delFaqItem(i)"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <el-form-item>
                    <div class="btn">
                        <div class="button" @click="updateConfirm">
                            <span>提交</span>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>

import aliOss from '../../../aliOss/index'
import upload from '../../../components/file/upload'
import { VueEditor } from "vue2-editor"

export default({
    name: 'psc-malfunction-update',
    data() {
        return {
            searchData: {
                product: '',
                lang: 'zh'
            },
            mConfig: '',
            mconfigFile: [],
            addData: [],
            editIndex: 0,
            imgShow: false,
            videoShow: false,
            customEditorToolbar: [
                [{ header: [1, 2, 3, 4, 5] }],
                ["bold", "italic", "underline", "strike"],
                [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }],
                [{color: []}, {background: []}]
            ]
        }
    },
    components: {
        upload,
        VueEditor
    },
    computed: {
        fileDire() {
            return `${this.searchData.product}/${this.searchData.lang}/malfunction`
        }
    },
    watch: {
        searchData: {
            deep: true,
            handler(nD, oD) {
                if(nD.product && nD.lang) {
                    this.addData = (this.mConfig && this.mConfig[nD.product] && this.mConfig[nD.product][nD.lang] && this.mConfig[nD.product][nD.lang]['malfunction']) ? this.mConfig[nD.product][nD.lang]['malfunction'] : [];
                    this.mconfigFile = [...this.addData];
                    this.getFileUrl();
                }
            }
        }
    },
    created() {
        this.getConfig();
    },
    methods: {
        getFileUrl() {
            if(this.mconfigFile.length == 0) {
                this.imgShow = true;
                this.videoShow = true;
            }else{
                for(let i = 0; i < this.mconfigFile.length; i++) {
                    if(this.mconfigFile[i].img){
                        aliOss.preview(this.mconfigFile[i].img.split('product-service-center/')[1]).then(url => {
                            this.mconfigFile[i].imgUrl = [url];
                            
                        })
                    }else{
                        if(i == this.mconfigFile.length - 1) {
                            this.imgShow = true;
                        }
                    }
                    if(this.mconfigFile[i].video){
                        aliOss.preview(this.mconfigFile[i].video.split('product-service-center/')[1]).then(url => {
                            this.mconfigFile[i].videoUrl = [url];
                            if(i == this.mconfigFile.length - 1) {
                                this.videoShow = true;
                            }
                        })
                    }else{
                        if(i == this.mconfigFile.length - 1) {
                            this.videoShow = true;
                        }
                    }
                }
            }
        },
        getConfig() {
            aliOss.getFile('config.json').then(r => {
                this.mConfig = JSON.parse(r.content);
                console.log(this.mConfig )
                this.searchData.product = 'M1';
            })
        },
        fileChangeImg(file, type, i) {
            if(type == 'upload') {
                this.addData[this.editIndex]['img'] = file;
            }else{
                // this.delFile(this.addData[this.editIndex]['img']);
                this.addData[this.editIndex]['img'] = '';
                if(this.editIndex < this.mconfigFile.length){
                    delete this.mconfigFile[this.editIndex].imgUrl;
                }
            }
        },
        fileChangeVideo(file, type, i) {
            if(type == 'upload') {
                this.addData[this.editIndex]['video'] = file;
            }else{
                // this.delFile(this.addData[this.editIndex]['video']);
                this.addData[this.editIndex]['video'] = '';
                if(this.editIndex < this.mconfigFile.length){
                    delete this.mconfigFile[this.editIndex].videoUrl;
                }
            }
        },
        delFile(directory) {
            aliOss.delFile(directory)
        },
        updateConfirm() {
            if(!this.mConfig[this.searchData.product]) {
                this.mConfig[this.searchData.product] = {
                    [this.searchData.lang]: {
                        malfunction: {},
                    }
                };
            }else if(!this.mConfig[this.searchData.product][this.searchData.lang]) {
                this.mConfig[this.searchData.product][this.searchData.lang] = {};
                this.mConfig[this.searchData.product][this.searchData.lang].malfunction = {};
            }
            if(this.addData.length == 0) {
                delete this.mConfig[this.searchData.product][this.searchData.lang]['malfunction'];
            }else{
                this.mConfig[this.searchData.product][this.searchData.lang]['malfunction'] = this.addData;
            }
            aliOss.putFile('config.json', this.mConfig, 'application/json').then(r => {
                this.$message.success('提交成功!');
            })
        },
        addFaqItem(i) {
            const obj = {
                type: '',
                content: '',
                img: '',
                video: ''
            };
            if(i) {
                this.addData.splice(i, 0, obj)
            }else{
                this.addData.push(obj);
            }  
        },
        delFaqItem(i) {
            this.addData.splice(i, 1);
        },
    }
})
</script>
<style lang="less" scoped>
    .el-form{
        max-width: 800px;
        .faq_title{
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 20px;
            .flexLayout(flex-start);
            .add_faq{
                color: @colorBlue;
                font-size: 22px;
                margin-left: 10px;
            }
        }
        .add_item{
            position: relative;
            .el-form-item{
                margin-bottom: 10px;
            }
            .textarea_item{
                padding-bottom: 10px;
                border-bottom: 1px dashed #999;
            }
            .act_box{
                position: absolute;
                right: -70px;
                top: 3px;
                width: 60px;
                font-size: 20px;
                color: @colorDel;
                cursor: pointer;
                .add_faq{
                    color: @colorBlue;
                    font-size: 22px;
                    margin-right: 10px;
                }
            }
            /deep/.ql-editor{
                min-height: 100px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/app/product-service-center/malfunction-update.vue